/* RESPONSIBLE TEAM: team-data-foundations */
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class ChannelIdentityRulesNewRoute extends WorkspaceSettingsRoute {
  @service declare intl: IntlService;

  queryParams = {
    fallback: { refreshModel: true },
  };

  get titleToken() {
    return this.intl.t('new-settings.workspace.channel-identity-rules.modal.add-title');
  }

  model(params: { fallback?: string }) {
    return {
      isFallback: params.fallback === 'true',
    };
  }
}
